import { render, staticRenderFns } from "./MalaysiaFlag.vue?vue&type=template&id=1aec0d41&"
import script from "./MalaysiaFlag.vue?vue&type=script&lang=js&"
export * from "./MalaysiaFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports